import React, { useEffect, useState } from 'react'
import { onWarning } from '../messages'
import { useTextResources } from '../../../language';
import PropTypes from "prop-types";
import { UserHasPermission } from '../permissionsActions';

const ValidateModalPermission = ({ open, onClose, actionId, children }) => {
    const [hasPermission, setHasPermission] = useState(false)
    const text = useTextResources()

    useEffect(() => {
        if (open && (window.optima?.user?.ActionIDs?.length > 0 || window.SelfieSettings?.settings?.user?.actions)) {
            const validateIfHasPermission = UserHasPermission(actionId);
            if (hasPermission != validateIfHasPermission) {
                setHasPermission(validateIfHasPermission);
            }
            if (!validateIfHasPermission) {
                onWarning(text('NoPermission'));
                if (onClose) onClose();
            }
        }
    }, [open])

    return hasPermission && <>{children}</>
}

ValidateModalPermission.propTypes = {
    children: PropTypes.any,
    actionId: PropTypes.number,
    rest: PropTypes.func,
    open: PropTypes.bool,
    onClose: PropTypes.func
}

export default ValidateModalPermission